var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEffect4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 165,
    viewBox: "0 0 204 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.141 48.2312C144.624 73.3171 136.031 105.39 110.946 119.873C85.8596 134.356 53.7863 125.764 39.3035 100.678C24.8207 75.5921 33.4129 43.5187 58.4988 29.0359C83.5846 14.5531 115.658 23.1453 130.141 48.2312Z",
    fill: "url(#paint0_linear_3452_16015)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.725 121.803L141.471 105.946L134.85 112.06L150.599 123.265L149.725 121.803Z",
    fill: "#323556"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7383 58.6176L107.297 140.903L142.417 104.131L59.7383 58.6176Z",
    fill: "#323556"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.298 143.612C107.189 143.612 107.081 143.612 106.973 143.591C106.126 143.49 105.375 142.995 104.948 142.257L57.3968 59.9785C56.7874 58.929 56.9567 57.5952 57.8098 56.7285C58.6561 55.8618 59.9832 55.6655 61.053 56.2478L143.731 101.761C144.469 102.167 144.977 102.892 145.099 103.725C145.228 104.558 144.964 105.397 144.381 106.007L109.268 142.779C108.753 143.314 108.042 143.618 107.311 143.618L107.298 143.612ZM66.9504 65.6795L107.839 136.421L138.03 104.808L66.9504 65.6795Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7383 58.6176L169.08 74.6373L152.275 93.2232L59.7383 58.6176Z",
    fill: "#323556"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M152.276 95.9315C151.958 95.9315 151.64 95.8774 151.328 95.7623L58.7914 61.1566C57.4982 60.6691 56.7737 59.2879 57.119 57.9472C57.4643 56.6066 58.7643 55.7467 60.132 55.9431L169.467 71.9628C170.456 72.105 171.282 72.7889 171.62 73.7232C171.959 74.6644 171.749 75.7139 171.079 76.4587L154.28 95.0446C153.759 95.6201 153.021 95.9383 152.269 95.9383L152.276 95.9315ZM84.4867 64.9821L151.497 90.0409L163.665 76.5805L84.4867 64.9821Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7402 58.6176L142.419 104.131L150.598 123.265L152.277 93.2233L59.7402 58.6176Z",
    fill: "url(#paint1_linear_3452_16015)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M150.598 125.974C149.528 125.974 148.539 125.337 148.106 124.328L140.292 106.054L58.4331 60.9942C57.1873 60.3103 56.6863 58.7801 57.2753 57.4936C57.8712 56.2072 59.354 55.591 60.6878 56.0853L153.225 90.691C154.335 91.104 155.046 92.1941 154.978 93.379L153.299 123.421C153.231 124.68 152.304 125.716 151.065 125.94C150.909 125.967 150.746 125.98 150.591 125.98L150.598 125.974ZM93.6346 74.1837L143.725 101.754C144.253 102.046 144.673 102.506 144.91 103.061L148.546 111.559L149.467 95.0581L93.6346 74.1837Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M150.597 125.974C150.055 125.974 149.506 125.811 149.026 125.473L133.277 114.267C132.058 113.4 131.774 111.708 132.64 110.489C133.507 109.27 135.2 108.986 136.418 109.852L152.167 121.058C153.386 121.925 153.67 123.617 152.804 124.836C152.276 125.581 151.443 125.974 150.597 125.974Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3452_16015",
    x1: 39.2994,
    y1: 100.69,
    x2: 130.134,
    y2: 48.2466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#573BD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#383649"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3452_16015",
    x1: 59.7402,
    y1: 90.9415,
    x2: 152.277,
    y2: 90.9415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#573BD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#323556"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEffect4);
export default __webpack_public_path__ + "static/media/effect4.4a5cf9ee0e102b9e27e314b472582313.svg";
export { ForwardRef as ReactComponent };